/* eslint-disable no-param-reassign */
export default class RemoteFileItemReader {
  static read(file) {
    return new Promise((resolve, reject) => {
      if (file.content) {
        resolve(file);
        return;
      }

      if (!file.url) {
        resolve(file);
        return;
      }

      if (file.binary) {
        this.readBinary(file, resolve, reject);
      } else {
        this.readText(file, resolve, reject);
      }
    });
  }

  static readBinary(file, resolve, reject) {
    const request = new XMLHttpRequest();
    request.open('GET', file.url, true);
    request.responseType = 'blob';
    request.onload = () => {
      file.blob = request.response;
      resolve(file);
    };

    request.onerror = (error) => {
      reject(error);
    };

    request.send();
  }

  static readText(file, resolve, reject) {
    const request = new XMLHttpRequest();
    request.open('GET', file.url, true);

    request.onload = () => {
      if (request.status === 400) {
        reject(request.responseText);
      } else {
        file.content = request.responseText;
        resolve(file);
      }
    };

    request.onerror = (error) => {
      reject(error);
    };

    request.send();
  }
}
